import { useCallback, useEffect } from 'react';
import { hydrateArticleTags } from '../../../../utils/tagUtils';

const ARTICLE_SYNC_FIELDS = [
  'valuation',
  'likes',
  'comments',
  'tier',
  'subscribersNumber',
  'viewsNumber',
  'likesNumber',
  'commentsNumber'
];

const useArticleModalArticleUpdates = ({
  article,
  availableTags,
  localArticle,
  onArticleUpdated,
  setLocalArticle
}) => {
  const applyArticleUpdate = useCallback((updatedArticle) => {
    const articlePayload = updatedArticle?.data || updatedArticle?.article || updatedArticle;
    if (!articlePayload?._id) return;

    const hydratedArticle = hydrateArticleTags(articlePayload, availableTags);

    setLocalArticle(prev => (
      prev?._id === hydratedArticle._id
        ? { ...prev, ...hydratedArticle }
        : hydratedArticle
    ));

    if (onArticleUpdated) {
      onArticleUpdated(hydratedArticle);
    }
  }, [availableTags, onArticleUpdated, setLocalArticle]);

  useEffect(() => {
    if (!article || !localArticle) return;

    const needsUpdate = ARTICLE_SYNC_FIELDS.some(field => article[field] !== localArticle[field]);
    if (!needsUpdate) return;

    setLocalArticle(prev => ({
      ...(prev || {}),
      ...ARTICLE_SYNC_FIELDS.reduce((nextFields, field) => ({
        ...nextFields,
        [field]: article[field]
      }), {})
    }));
  }, [article, localArticle, setLocalArticle]);

  return { applyArticleUpdate };
};

export default useArticleModalArticleUpdates;
